<template>
  <router-view />
</template>
<script>
import "@/assets/js/jquery.js";
import "@/assets/js/bootstrap.min.js";
import "@/assets/js/owl.carousel.min.js";
import "@/assets/js/jquery.counterup.min.js";
import "@/assets/js/jquery.colorbox.js";
import "@/assets/js/ini.isotope.js";
import "@/assets/js/custom.js";

export default {
  name: "App",
  metaInfo: {
    title: "Johnson Styles Construction",
    titleTemplate: "%s | Johnson Construction",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Johnson styles construction is construction company that provides a wide variety of  renovation services, building services, landscaping services and many more. "
      }
    ]
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
